import React from 'react'
import Link from 'gatsby-link'
import Game from "../components/rgb/components/Game";
import StoreLinks from "../components/storeLinks";

import { extractGameFromUrl } from "../util/shareGame";

const fallbackGameSpec = {
  seed: "fallback",
  gridSize: 4,
  colourCount: 3,
  remove: 4,
  title: "Sample RGB Logic Game"
}

export default class PlayPage extends React.Component {

  state = {
    gameSpec: null
  };

  componentDidMount() {
    const gameSpec = extractGameFromUrl();
    console.log(gameSpec);
    if (gameSpec) {
      this.setState({ gameSpec });
    }
  }

  render() {
    return <div>
      <h1>Shared Game</h1>
      <p>This game of RGB Logic has been shared with you. Just tap or click on a square to change the colour. Tap again to go to next colour.</p>

      <p>The fundamental rule of RGB logic is <strong>You must place exactly one of each colour in every row and column</strong>. This holds for all puzzles (even the most complex).</p>

      <p>You must also match the clues on the outside. <strong>The closest <em>occupied</em> square to the outside clues must match the colour of the clue</strong>.
      You should match downwards from the top, rightwards from the left and so on.
      </p>

      {this.state.gameSpec ?
        <Game {...this.state.gameSpec} />
        : <div>
          <h2>Invalid Link</h2>
          <p>Sorry this link looks invalid. But here is a game of RGB Logic to try out.</p>
          <Game {...fallbackGameSpec} />
        </div>
      }
      <h1>Download</h1>

      <p>Get RGB Logic for iOS and Android. It is free and comes with new puzzles every day.</p>

      <StoreLinks androidStoreLink="https://play.google.com/store/apps/details?id=uk.amimetic.rgb.logic.pro&hl=en_GB"
        iOSStoreLink="https://itunes.apple.com/gb/app/rgb-logic-buchstabensalat-logic-puzzles/id1097300530?mt=8" />

      <h1>Share</h1>

      <p>Please let others know about RGB Logic. It is fun and free. And might make you smarter. Thanks.</p>

      <a href="http://www.facebook.com/sharer/sharer.php?u=https://rgb-logic.amimetic.co.uk"
        alt="Share on Facebook"><div className="webLinkLarge">Share on Facebook</div></a>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/pages/play.js